import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum PanelReportsAccountsResolverErrorStatesEnum {
    GetTradingGroupsFailed = ErrorStateScheduleEnum.ReportsAccountsResolverErrorStatesStartIndex,
    GetCurrencyListFailed
}
